import SplitpanesPane from './SplitpanesPane';


SplitpanesPane.install = function(Vue) {
  Vue.component(SplitpanesPane.name, SplitpanesPane);
};

export default SplitpanesPane;
